import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import {User} from "@/interface"
import API from "@/api"

@Module({namespacedPath: "user/"})
export default class UserModule extends VuexModule {

  @getter
  public users: User[] = []

  @mutation
  setUsers(users: User[]) {
    this.users = users
  }

  @action()
  async fetchUsers(force: boolean = false) {
    if (this.users.length === 0 || force) {
      const users = await API.getUsers()
      this.setUsers(users)
    }
  }

  @action()
  async updateUser(user: User): Promise<void> {
    await API.updateUser(user)
  }
}